import React from 'react';
import QRCode from "qrcode.react";
import {Button, Modal} from "antd";

export const SignatureModal = props => {
    const { showCode, baseUrl, onCancel, onSubmit } = props;
   return (
        <Modal
            destroyOnClose={true}
            wrapClassName="video-config"
            title="电子签名"
            visible={showCode}
            onCancel={onCancel}
            closable={false}
            footer={null}
        >
            <div style={{ margin: 30, textAlign: 'center', height: 300 }}>
                <p>请使用手机扫描下方二维码，完成手写电子签名，该签名将用于您在司法审判过程中所有文书的签字</p>
                <QRCode
                    value={`${baseUrl}/InternetCourt/signature?token=${sessionStorage.getItem('token')}`}  //value参数为生成二维码的链接
                    size={120} //二维码的宽高尺寸
                    fgColor="#000000"  //二维码的颜色
                />
                <div>
                    <Button type="primary" style={{ borderRadius: 0, marginTop: 40 }} onClick={onCancel}>取消</Button>
                    <Button type="primary" style={{ marginLeft: 20, borderRadius: 0, marginTop: 40 }} onClick={()=>{ onSubmit('', 1); onCancel() }}>已提交签名</Button>
                </div>
            </div>
        </Modal>
   )
}
